import React from 'react'

export default function Explain() {
  return (
    <div id="explain" className="center">
      <div className="text_container">
        <h2 className="title">
          Qu'est ce que le 3W-CODE ?
        </h2>
        <p className="text">
          Le 3W-CODE est une formation de 3 semaines intégralement en ligne permettant à un total débutant en programmation de devenir développeur web confirmé, capable de créer tout type de sites web.
        </p>
      </div>
    </div>
  )
}
